import React from 'react';

import { Modal } from './Modal';

export const InfoModal = ({ isOpen, handleClose, category }) => {
  return (
    <Modal isOpen={isOpen} handleClose={handleClose}>
      <div className="map-modal-container">
        {(category === 'ENROUTE' || category === 'ALTN') && (
          <div className="map-modal-column">
            <div className="map-modal-paragraph">
              <p style={{ color: 'rgb(255,0,255)' }}>MAGENTA</p>
              <span style={{ textAlign: 'center' }}>
                {' '}
                LIFR (Low Instrument Flight Rules){' '}
              </span>
              <span style={{ textAlign: 'center' }}>
                Ceiling below 500 feet AGL and/or visibility less than 1600m
              </span>
            </div>

            <div className="map-modal-paragraph">
              <p style={{ color: 'rgb(255,0,0)' }}>RED</p>
              <span style={{ textAlign: 'center' }}>
                {' '}
                IFR (Instrument Flight Rules){' '}
              </span>
              <span style={{ textAlign: 'center' }}>
                Ceiling 500 to below 1000 feet AGL and/or visibility 1600m to
                less than 4800m
              </span>
            </div>

            <div className="map-modal-paragraph">
              <p style={{ color: 'rgb(0,0,255)' }}>BLUE</p>
              <span style={{ textAlign: 'center' }}>
                {' '}
                MVFR (Marginal Visual Flight Rules){' '}
              </span>
              <span style={{ textAlign: 'center' }}>
                Ceiling 1000 to 3000 feet AGL and/or visibility 4800m to 8000m{' '}
              </span>
            </div>

            <div className="map-modal-paragraph">
              <p style={{ color: 'rgb(50,205,50)' }}>GREEN</p>
              <span style={{ textAlign: 'center' }}>
                {' '}
                VFR (Visual Flight Rules){' '}
              </span>
              <span style={{ textAlign: 'center' }}>
                Ceiling greater than 3000 feet AGL and visibility greater than
                8000m
              </span>
            </div>

            <div className="map-modal-paragraph">
              <p style={{ color: 'rgb(160,82,45)' }}>BROWN</p>
              <span style={{ textAlign: 'center' }}>
                {' '}
                No information found{' '}
              </span>
            </div>
          </div>
        )}

        {/* TURB INFORMATION */}
        <div className="map-modal-column">
          <p>TURB</p>

          <div className="map-modal-paragraph">
            <p style={{ color: 'red' }}>RED</p>
            <span style={{ textAlign: 'center' }}>
              {' '}
              Segment Shear Rate {'>'} 5
            </span>
          </div>

          <div className="map-modal-paragraph">
            <p style={{ color: '#8A6B00' }}>YELLOW</p>
            <span style={{ textAlign: 'center' }}>
              {' '}
              Segment Shear Rate {'>'} 2 and {'<'} 6
            </span>
          </div>

          <div className="map-modal-paragraph">
            <p style={{ color: 'green' }}>GREEN</p>
            <span style={{ textAlign: 'center' }}>
              {' '}
              Segment Shear Rate {'<'} 3
            </span>
          </div>
        </div>
      </div>
    </Modal>
  );
};
